import { ReactElement } from 'react';

import { Box } from '@twilio-paste/core/box';

import ReactHelmet from '../reactHelmet';
import { WiseOwlView } from '../wiseOwlView';
import { copy } from './definitions';
import styles from './landing.module.css';

const Landing = (): ReactElement => {
  return (
    <Box as="main" className={styles.landingContainer}>
      <ReactHelmet title={copy.reactHelmet.title} />

      <WiseOwlView />
    </Box>
  );
};

export default Landing;
